module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAU9JREFUWEftlrFKw1AUhv+TSBcXHaQpUsQXEBFK4u6o6FuoScEqFEdxE0FaMbGLg08gKvgOvSIOPoAIKqY66FBQsemRFuNkoIGbxOHe9Vzu//Gdy72HkPGijPOhAJSBRAyU7OdpXQuazJQDU1Uc5veiLnsiAKbjLxLhtBfKjLrwjHUFIN2AudqaIr271dccaNuikb8JQ1JpgVn21wio9wGAinCNfQUg3cDsyv0460NzRPT11H4/uTue/PgNSaMFptPaJeJqL7RLPH95ULhIGcCvEaHy86AsCc84UwDKQKoGLNtfgIYNAJ1O8Ll81Zi4DQEs52UGFOwAILC+2fTGrsNayX4sapp+REAOQK3pGufS/wJZw2wi80AcuEgAy/EfmDAc57DovdwWbqH4Vz0SwCz7rwSMyABg4E24xmgsABnBg5zxf+/AIPQy9igDmRv4BgI2BjAqU+GiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_mtcynjyl.png
// module id = E521
// module chunks = 44